import { Box, CircularProgress } from '@mui/material';
import Div100vh from 'react-div-100vh';

export const Loading = () => (
  <Div100vh>
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        height: '100%',
        width: '100%',
      }}
    >
      <CircularProgress />
    </Box>
  </Div100vh>
);
